import { render } from "./UsersForm.vue?vue&type=template&id=f044ac78"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__